import * as yup from 'yup';

export const companyProfileSchema = yup.object().shape({
  website: yup.string().url('Website must be a valid URL (e.g., https://example.com)'),
  slug: yup.string().required('Profile URL is required field'),
});
